import { useState } from "react";
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance";
import Form from "../../../Partials/Layouts/Forms/Form";
import ShortTextInput from "../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput";
import FormSubmitButton from "../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";

function CreateState({ setShowCreateForm, setShowModal, triggerFetch, stateId }) {

  const [name, setName] = useState("");

  const axiosInstance = useAxiosInstance();

  async function handleSubmit(e) {
    e.preventDefault();
    const itemData = new FormData();

    itemData.append("name", name);
    itemData.append("state", stateId);

    const response = await axiosInstance.post("states/cities/allCitiesByStateId/" + stateId, itemData);

    if (response) {
      setShowCreateForm(false);
      setShowModal(false);
      triggerFetch();
    }
  }

  return (
    <Form onSubmit={handleSubmit} hasImage>
      <ShortTextInput
        label={`City Name`}
        value={name}
        placeholder={`Enter City Name`}
        setState={setName}
      />
      <FormSubmitButton text="Create City" />
    </Form>
  );
}

export default CreateState;
